import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { getCurrentCircleLocale } from "@/react/helpers/localeHelpers";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers/settingsNavPathV3";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import paywallSetupImageEnglish from "./bannerImageEnglish.png";
import paywallSetupImagePortuguese from "./bannerImagePt.png";

const localeRoot = "community_onboarding.new_checklist.paywall_info_modal";

export const PaywallInfoModalContent = () => {
  const locale = getCurrentCircleLocale();

  const imageSrc =
    locale === "pt" ? paywallSetupImagePortuguese : paywallSetupImageEnglish;

  const handleConnectStripe = () => {
    window.open(settingsNavPathV3.paywalls.index, "_blank");
  };

  const handleLearnMore = () => {
    // eslint-disable-next-line sonarjs/link-with-target-blank -- Disabled for plugin version update. Fix when possible.
    window.open("https://help.circle.so/p/payments", "_blank");
  };

  return (
    <div className="flex flex-col items-center gap-6 pb-8">
      <img
        src={imageSrc}
        alt=""
        className="mt-4 w-full rounded-lg sm:mt-0"
        loading="eager"
      />
      <div>
        <Typography.BodyMd color="text-default">
          {t(`${localeRoot}.description_1`)}
        </Typography.BodyMd>
        <Typography.BodyMd color="text-default">
          {t(`${localeRoot}.description_2`)}
        </Typography.BodyMd>
      </div>
      <div className="mt-2 flex w-full flex-row justify-end gap-2">
        <Button variant="secondary" onClick={handleLearnMore}>
          {t(`${localeRoot}.learn_more`)}
        </Button>
        <Button variant="circle" onClick={handleConnectStripe}>
          <div className="flex flex-row items-center justify-center gap-1">
            <div>{t(`${localeRoot}.connect_stripe`)}</div>
            <Icon type="16-arrow-top-right" size={16} />
          </div>
        </Button>
      </div>
    </div>
  );
};
